import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Adiciona JWT Bearer em todas as requisições (se houver token)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rota017_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Em caso de 401, limpa o token (usuário precisa relogar)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('rota017_token')) {
      localStorage.removeItem('rota017_token');
    }
    return Promise.reject(error);
  }
);

// AUTH
export const solicitarOTP = (telefone) => api.post('/auth/solicitar-otp', { telefone });
export const verificarOTP = (telefone, codigo, remember = false) => api.post('/auth/verificar-otp', { telefone, codigo, remember });
export const cadastrarEmpresa = (telefone, empresa) => api.post('/auth/cadastrar-empresa', { telefone, empresa });

// EMPRESAS
export const obterEmpresa = (empresaId) => api.get(`/empresas/${empresaId}`);
export const listarEmpresas = (perfil) => api.get('/empresas', { params: { perfil } });

// PAGAMENTOS
export const criarPagamento = (data) => api.post('/pagamentos/criar', data);
export const obterPagamento = (pagamentoId) => api.get(`/pagamentos/${pagamentoId}`);
export const listarPagamentosEmpresa = (empresaId) => api.get(`/pagamentos/empresa/${empresaId}`);
export const simularAprovacao = (pagamentoId) => api.post(`/pagamentos/${pagamentoId}/simular-aprovacao`);

// ENTREGAS
export const criarEntrega = (data) => api.post('/entregas', data);
export const obterEntrega = (entregaId) => api.get(`/entregas/${entregaId}`);
export const listarEntregas = (params) => api.get('/entregas', { params });
export const atualizarStatusEntrega = (entregaId, data) => api.patch(`/entregas/${entregaId}/status`, data);

// USUÁRIOS
export const criarUsuario = (data) => api.post('/usuarios', data);
export const listarUsuariosEmpresa = (empresaId) => api.get(`/usuarios/empresa/${empresaId}`);

// RELATÓRIOS
export const relatorioEmpresa = (empresaId, params) => api.get(`/relatorios/empresa/${empresaId}`, { params });

// ADMIN
export const adminDashboard = () => api.get('/admin/dashboard');
export const verificarBloqueios = () => api.post('/admin/verificar-bloqueios');

export default api;
